/* eslint-disable no-unused-vars */
import React, {useEffect, useState} from 'react'
import {getAuthByRole} from '../utils/get-screen-auth-by-role'
import {AUTHORIZED_ROLES_BY_SCREENS} from '../utils/constants'
import {useUserRoles} from '../utils/use-user-roles'
import {NavLink} from 'react-router-dom'
import {TabOptionsContainer} from './ui/sidebar'

function setAccountsSubLinks(roles) {
  const accountsSubLinks = [
    {
      name: 'My Accounts',
      url: '/accounts/my-accounts',
    },
  ]
  const {allAccount} = AUTHORIZED_ROLES_BY_SCREENS
  if (getAuthByRole(allAccount, roles)) {
    accountsSubLinks.push({
      name: 'All Accounts',
      url: '/accounts/all-accounts',
    })
  }
  return accountsSubLinks
}

function setAppointmentsSubLinks(roles) {
  const appointmentsSubLinks = []
  const {demoRequests, appointments} = AUTHORIZED_ROLES_BY_SCREENS

  if (getAuthByRole(demoRequests, roles)) {
    appointmentsSubLinks.push({
      name: 'Demo Requests',
      url: '/demo-requests',
    })
  }
  if (getAuthByRole(appointments, roles)) {
    appointmentsSubLinks.push({
      name: 'Onboarding',
      url: '/appointments',
    })
  }
  return appointmentsSubLinks
}

const TabOptions = ({screen}) => {
  const [options, setOptions] = useState([])
  const {roles} = useUserRoles()
  const stringifiedRoles = JSON.stringify(roles)

  useEffect(() => {
    if (screen === 'accounts') {
      setOptions(setAccountsSubLinks(JSON.parse(stringifiedRoles)))
    } else if (screen === 'appointments') {
      setOptions(setAppointmentsSubLinks(JSON.parse(stringifiedRoles)))
    }
  }, [screen, stringifiedRoles])
  return (
    <div style={{marginLeft: '-17px'}}>
      <TabOptionsContainer>
        {options.map(option => (
          <NavLink
            key={option.name}
            to={option.url}
            style={({isActive}) => ({
              display: 'inline-block',
              padding: '4px 14px',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '500',
              textDecoration: 'none',
              color: isActive ? '#000000' : '#6F6F6F',
              background: isActive ? '#FFFFFF' : 'transparent',
              border: isActive ? '1px solid #D0D0D0' : '1px solid transparent',
              boxShadow: isActive ? '0 1px 2px rgba(0,0,0,0.06)' : 'none',
            })}
          >
            {option.name}
          </NavLink>
        ))}
      </TabOptionsContainer>
    </div>
  )
}

export {TabOptions}
